import React from 'react'
import { MainDiv } from '../Default/MainDiv'
import { DateWiseSearch } from './DateWiseSearch'
export const CombinedData=() =>{
  
  return (
    <>
    <MainDiv>
    <DateWiseSearch />
   </MainDiv> 
    </>
    
  )
}
